import TaxFederalBracketsPage from '@playground/features/dictionary/TaxFederalBracketsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/tax-federal-brackets'
)({
  component: TaxFederalBracketsPage,
})
